export default "/images/svartalfr-button.png?a54687b37e67685176445029fc6f270a";